import './style/index.less';
import AccountLogin from './AccountLogin';

export default AccountLogin;
